import { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { User } from '@supabase/supabase-js';

function getSessionStartTime(): number {
	let startTime = sessionStorage.getItem('session_start_time');
	if (!startTime) {
		startTime = Date.now().toString();
		sessionStorage.setItem('session_start_time', startTime);
	}
	return Number(startTime);
}

export function useSessionDurationTracking(user: User) {
	useEffect(() => {
		if (!user) return;

		const startTime = getSessionStartTime();
		mixpanel.identify(user.id)
		mixpanel.people.set({
			'$name': user.user_metadata?.name,
			'$email': user.email,
		});

		const handleEndSession = () => {
			const endTime = Date.now();
			const durationMs = endTime - startTime;
			const durationSeconds = Math.round(durationMs / 1000);

			// mixpanel.track('Session End', {
			// 	userId: user.id,
			// 	userEmail: user.email,
			// 	duration_seconds: durationSeconds,
			// 	endedAt: new Date(endTime).toISOString(),
			// });


			sessionStorage.removeItem('session_start_time');
		};

		window.addEventListener('beforeunload', handleEndSession);

		return () => {
			window.removeEventListener('beforeunload', handleEndSession);
			handleEndSession();
		};
	}, [user]);
}
